import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { AdjustmentKind, RentalObjectCategory } from '../../model/const/enums';

export interface ChangeRentalObjectCategoryRequest {
  rentalObjectId: string;
  rentalObjectTypeId: string;
  buildingId?: string;
  entranceId?: string;
}

export interface ChangeRentalObjectCategoryResponse {
  category: RentalObjectCategory;
  missingArticles: MissingRentalObjectCategoryArticle[];
}

export interface MissingRentalObjectCategoryArticle {
  vatPercent: number;
  adjustment: AdjustmentKind;
  category: RentalObjectCategory;
  affectedRowCount: number;
}

@Injectable()
export class RentalObjectCategoryService {
  private readonly endpoint: string;

  constructor(
    private readonly client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig,
    private readonly progressBar: ProgressBarService
  ) {
    this.endpoint = `${config.apiEndpointV2}/rental-objects`;
  }

  changeCategory(request: ChangeRentalObjectCategoryRequest): Observable<ChangeRentalObjectCategoryResponse> {
    this.progressBar.start();
    return this.client
      .post<ChangeRentalObjectCategoryResponse>(`${this.endpoint}/change-category`, request)
      .pipe(finalize(() => this.progressBar.stop()));
  }
}
